import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import CreditnoteForm from "@components/forms/CreditNoteForm";
import DocumentReferencesOffCanvas from "@components/layout/Offcanvas/DocumentReferencesOffCanvas";
import { OpenDocumentReferencesPubSub } from "@utils/pubsubs/PubSub";
import { useAppSelector } from "@/store/hooks";

type CreditnoteAddProps = {
  priceNote?: boolean
}

const CreditnoteAdd = (props: CreditnoteAddProps) => {
  const { priceNote = false } = props
  const documentReferences = useAppSelector((state) => state.eDocument.documentReferences)
  const params = useParams()
  const { invoiceId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Agregar Nota de Credito"
      backUrl="/user/creditnotes"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "creditnoteAdd",
          type: "submit",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: `Referencias de Documento (${documentReferences.length})`,
          onClick: () => {
            OpenDocumentReferencesPubSub.publish({ openOffCanvas: true, documentKind: "Creditnote" })
          }
        }
      ]}
    >
      <CreditnoteForm
        invoiceId={`${invoiceId}`}
        saveRedirectUrl="/user/creditnotes"
        formId="creditnoteAdd"
        priceNote={priceNote} >
      </CreditnoteForm>

      <DocumentReferencesOffCanvas />

    </PageContainer>
  );
}

export default CreditnoteAdd;
